import { render, staticRenderFns } from "./sendTemplate.vue?vue&type=template&id=9b510184&scoped=true"
import script from "./sendTemplate.vue?vue&type=script&lang=js"
export * from "./sendTemplate.vue?vue&type=script&lang=js"
import style0 from "./sendTemplate.vue?vue&type=style&index=0&id=9b510184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b510184",
  null
  
)

export default component.exports